import { DiscountScopes } from '@invivodf/module-discount-sdk'

export const labeledScopes = [
  { text: 'ctx.discount.detail.on-articles', value: DiscountScopes.Article },
  { text: `ctx.discount.detail.on-group`, value: DiscountScopes.Group },
  { text: `ctx.discount.detail.on-mixed-group`, value: DiscountScopes.Mixed_group },
  { text: 'ctx.discount.detail.on-cart', value: DiscountScopes.Cart },
]
